import React, { useState, useEffect, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import ToggleButton from '@material-ui/lab/ToggleButton';
import Tooltip from '@material-ui/core/Tooltip';

import getLayerScale from '../functions/getBaseLayerDefaultScale';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 75,
    left: 60,
  },
  paper: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: 300,
  },
  margin: {
    margin: theme.spacing(1),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  layerButton: {
    backgroundColor: '#0C4C35',
    '&:hover': {
      backgroundColor: '#63D764'
    },
    '&.MuiToggleButton-root.Mui-selected': {
      backgroundColor: '#63D764',
      color: '#FFFFFF',
    },
    color: '#FFFFFF',
    width: 42,
    height: 42,
  }
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);


export default function BaseLayerPaper() {

  const classes = useStyles();
  const [state, dispatch] = useContext(SessionContext);
  const [uState] = useContext(UserContext);

  const [osmm, setOsmm] = useState(false);
  const [osmmbw, setOsmmbw] = useState(false);
  const [os10k, setOs10k] = useState(false);
  const [os25k, setOs25k] = useState(false);
  const [os50k, setOs50k] = useState(false);
  const [os250k, setOs250k] = useState(false);
  const [aerial, setAerial] = useState(false);

  const [isTraining, setIsTraining] = useState(false);
  const [osmmToolTip, setOsmmToolTip] = useState('Display coloured OS Mastermap as the basemap.');
  const [osmmbwToolTip, setOsmmbwToolTip] = useState('Display OS Mastermap B&W as the basemap.');
  const [os10kToolTip, setOs10kToolTip] = useState('Display OS 1:10,000 Mapping as the basemap.');
  const [os25kToolTip, setOs25kToolTip] = useState('Display OS 1:25,000 Mapping as the basemap.');
  const [os50kToolTip, setOs50kToolTip] = useState('Display OS 1:50,000 Mapping as the basemap.');
  const [os250kToolTip, setOs250kToolTip] = useState('Display OS 1:250,000 Mapping as the basemap.');
  const [aerialToolTip, setAerialToolTip] = useState('Display Aerial Imagery as the basemap.');
 
  /**
   * Disables certain buttons if in training mode.
   */
  useEffect(() => {
    if (uState.company.companytype == 'training') {
      setIsTraining(true);
      setOsmmToolTip('Training mode - coloured OS Mastermap basemap disabled.');
      setOsmmbwToolTip('Training mode - OS Mastermap B&W basemap disabled.')
    }
  },[uState]);

  /**
   * Selects the current selected layer/
   */
  useEffect(() => {
    if (typeof state.blayer !== 'undefined'){
      setSelectedLayer(state.blayer);
    }
  },[state.blayer]);

  /**
   * Sends request to change layer.
   */
  const setLayer = (layer) => {
    dispatch({
      type: "setViewScale",
      payload: { viewScale: getLayerScale(layer)}
    });
    dispatch({
      type: "setBaseLayer",
      payload: { layer: layer}
    });
  };


  /**
   * Sets the selected toogle button.
   */
  function setSelectedLayer(layer){
    //console.log("Selected layer display:"+layer);
    switch(layer){
      case "osmm":
        setOsmm(true);
        setOsmmbw(false);
        setOs10k(false);
        setOs25k(false);
        setOs50k(false);
        setOs250k(false);
        setAerial(false);
      break;
      case "osmmbw":
        setOsmm(false);
        setOsmmbw(true);
        setOs10k(false);
        setOs25k(false);
        setOs50k(false);
        setOs250k(false);
        setAerial(false);
        
      break;
      case "os10k":
        setOsmm(false);
        setOsmmbw(false);
        setOs10k(true);
        setOs25k(false);
        setOs50k(false);
        setOs250k(false);
        setAerial(false);
      break;
      case "os25k":
        setOsmm(false);
        setOsmmbw(false);
        setOs10k(false);
        setOs25k(true);
        setOs50k(false);
        setOs250k(false);
        setAerial(false);
      break;
      case "os50k":
        setOsmm(false);
        setOsmmbw(false);
        setOs10k(false);
        setOs25k(false);
        setOs50k(true);
        setOs250k(false);
        setAerial(false);
      break;
      case "os250k":
        setOsmm(false);
        setOsmmbw(false);
        setOs10k(false);
        setOs25k(false);
        setOs50k(false);
        setOs250k(true);
        setAerial(false);
      break;
      case "aerial":
        setOsmm(false);
        setOsmmbw(false);
        setOs10k(false);
        setOs25k(false);
        setOs50k(false);
        setOs250k(false);
        setAerial(true);
      break;
      default:
    }
    if (layer !== state.blayer){
      setLayer(layer); 
    }
  }


  //<HtmlTooltip title={<React.Fragment>{"OS 1:10,000 Mapping"}</React.Fragment>}></HtmlTooltip>
  return (
    <div className={classes.paper}>
        <HtmlTooltip title={<React.Fragment>{osmmToolTip}</React.Fragment>}>
          <span><ToggleButton className={classes.layerButton} value="osmm" selected={osmm} disabled={isTraining} onChange={() => { setSelectedLayer('osmm'); } }>MM</ToggleButton></span>
        </HtmlTooltip> 
        <HtmlTooltip title={<React.Fragment>{osmmbwToolTip}</React.Fragment>}>
          <span><ToggleButton className={classes.layerButton} value="osmmbw" selected={osmmbw} disabled={isTraining} onChange={() => { setSelectedLayer('osmmbw'); }}>OS</ToggleButton></span>
        </HtmlTooltip>
        <HtmlTooltip title={<React.Fragment>{os10kToolTip}</React.Fragment>}>
          <ToggleButton className={classes.layerButton} value="os10k" selected={os10k} onChange={() => { setSelectedLayer('os10k'); }}>ST</ToggleButton>
        </HtmlTooltip>
        <HtmlTooltip title={<React.Fragment>{os25kToolTip}</React.Fragment>}>
          <ToggleButton className={classes.layerButton} value="os25k" selected={os25k} onChange={() => { setSelectedLayer('os25k'); }}>TC</ToggleButton>
        </HtmlTooltip>
        <HtmlTooltip title={<React.Fragment>{os50kToolTip}</React.Fragment>}>
          <ToggleButton className={classes.layerButton} value="os50k" selected={os50k} onChange={() => { setSelectedLayer('os50k'); }}>TW</ToggleButton>
        </HtmlTooltip>
        <HtmlTooltip title={<React.Fragment>{os250kToolTip}</React.Fragment>}>
          <ToggleButton className={classes.layerButton} value="os250k" selected={os250k} onChange={() => { setSelectedLayer('os250k'); }}>GB</ToggleButton>
        </HtmlTooltip>
        <HtmlTooltip title={<React.Fragment>{aerialToolTip}</React.Fragment>}>
          <ToggleButton className={classes.layerButton} value="aerial" selected={aerial} onChange={() => { setSelectedLayer('aerial'); }}>IM</ToggleButton>
        </HtmlTooltip>
    </div>
  );
}